import React from 'react';
import { MenuItem } from '@mui/material';
import { IoMdCheckmark } from 'react-icons/io';

interface WindowFunctionMenuItemProps {
  isChecked: boolean;
  onClick: (event: React.MouseEvent<HTMLLIElement>) => void;
  optionName: string;
  isDisabled: boolean;
}

const WindowFunctionMenuItem: React.FC<WindowFunctionMenuItemProps> = ({
  isChecked,
  onClick,
  optionName,
  isDisabled,
}) => {
  return (
    <div style={{ display: "flex" }}>
      <span
        style={{
          color: "rgb(211, 211, 211)",
          paddingLeft: "5px",
          paddingTop: "4px",
          position: "absolute",
        }}
      >
        {isChecked ? <IoMdCheckmark style={{ color: "#7c7979" }} /> : null}
      </span>
      <MenuItem
        disabled={isDisabled}
        onClick={onClick}
        sx={{
          fontSize: "12px",
          padding: "2px 1.5rem",
          width: "100%",
        }}
      >
        {optionName || "Unnamed Option"}
      </MenuItem>
    </div>
  );
};

export default WindowFunctionMenuItem;
